import React, { useState } from "react";

import { PropertyImage } from "../../../definitions/property";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

interface ImageCarouselZoomProps {
  images: PropertyImage[];
  onClick: any;
  selectedIndex?: number;
}

const ImageCarouselZoom: React.FC<ImageCarouselZoomProps> = ({
  images,
  onClick,
  selectedIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(selectedIndex);

  return (
    <>
      <Lightbox
        mainSrc={images[currentIndex]?.image}
        nextSrc={images[(currentIndex + 1) % images.length]?.image}
        prevSrc={
          images[(currentIndex + images.length - 1) % images.length]?.image
        }
        imageTitle={images[currentIndex]?.title}
        onCloseRequest={() => {
          onClick();
        }}
        onMovePrevRequest={() =>
          setCurrentIndex((currentIndex + images.length - 1) % images.length)
        }
        onMoveNextRequest={() =>
          setCurrentIndex((currentIndex + 1) % images.length)
        }
      />
    </>
  );
};

export default ImageCarouselZoom;
